import twitch from "../../assets/twitch.svg";
import twitchBlack from "../../assets/twitch_black.svg";
import youtube from "../../assets/youtube.svg";
import youtubeGreen from "../../assets/youtube_green.svg";
import youtubeBlack from "../../assets/youtube_black.svg";
import youtubeTwitchCombo from "../../assets/yt_twitch_combo.webp";
import comboBlack from "../../assets/yt_twitch_combo_black.webp";

export function getPlatformIcons(style: "default" | "black") {
  if (style === "black") return { YT: youtubeBlack, YTMember: youtubeBlack, Twitch: twitchBlack, both: comboBlack };
  else return { YT: youtube, YTMember: youtubeGreen, Twitch: twitch, both: youtubeTwitchCombo };
}
